import React, { useState ,useEffect} from "react";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import useStyles from "./styles";
import BreadCrumb from "../../shared/BreadCrumb";
// import { settingsDetails } from "../../constants/Settings.constants";
import AddSettingsModal from "../../shared/AddSettingsModal";
import { SettingsModal } from "../../models/policy.model";
import { getSettingsReason, addSettingsReason, removeSettingsReason,getImagingCategories } from '../../services/policy.service';
import Loader from "../../shared/loader";
import { NotifyModel } from "../../models/Auth.model";
import Notify from "../../shared/Notify";
import { Button, FormHelperText } from "@material-ui/core";
import { ToastContainer, toast } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css";
import { hasPermission } from "../../services/hasPermission";
export default function Settings(props) {
  const settingsDetails = [
    {
        title: "Manage Suspense Reasons",
        addText: "Add Suspense Reasons:",
        removeText: "Remove Reason",
        maintainceType: "suspReason",
        columns: [
            {
                key: 'checkboxAll',
                label: ''
            },
            {
                key: 'description',
                label: 'Description'
            }
        ],
        disabled:hasPermission(["MANAGE SUSPENSE"]),
    },
    {
        title: "Maintain Policy Notes",
        addText: "Add Note:",
        removeText: "Remove Selected",
        maintainceType: "note",
        columns: [
            {
                key: 'checkboxAll',
                label: ''
            },
            {
                key: 'note',
                label: 'Note'
            },
            {
                key: 'addedBy',
                label: 'Added By'
            }
        ],
        disabled:hasPermission(["MANAGE POLICYNOTES"]),
    },
    {
        title: "Maintain Hold Reasons",
        addText: "Add Hold Reasons:",
        removeText: "Remove Reason",
        maintainceType: "reasonType",
        type:"holdReason",
        columns: [
            {
                key: 'checkboxAll',
                label: ''
            },
            {
                key: 'description',
                label: 'Description'
            }
        ]
    },
    {
        title: "Three Options Letter Reasons",
        addText: "Add Options Letter Reasons:",
        removeText: "Remove Reason",
        maintainceType: "threeOptions",
        columns: [
            {
                key: 'checkboxAll',
                label: ''
            },
            {
                key: 'description',
                label: 'Description'
            }
        ]
    },
    {
        title: "Maintain Imaging Categories",
        addText: "Add Image Categories:",
        removeText: "Remove Category",
        maintainceType: "imageCategory",
        columns: [
            {
                key: 'checkboxAll',
                label: ''
            },
            {
                key: 'type',
                label: 'Type'
            },
            {
                key: 'description',
                label: 'Description'
            }
        ]
    }
]
  const { match } = props
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState({
    static: {},
    dynamic: []
  })
  const [isLoading, setIsLoading] = useState(false);
  const [selected, setSelected] = useState([])
  const [selectdRow, setSelectedRow] = useState();
  const [notifyProps, setNotifyProps] = useState(NotifyModel);
  const [isLoader, setIsLoader] = useState(false);
  const [categories,setCategories] = useState([])
  const [load,setLoad] = useState(false);
  const [emptyFlag,setEmptyFlag] = useState(false)
  useEffect(()=>{
    getCategories()
    setEmptyFlag(false)
  },[emptyFlag])
  // Remove Multiple Reasons
  const handleRemove = () => {
    if(selected.length > 0){
    setLoad(true)
    removeSettingsReason(selected, selectdRow.maintainceType).then((result) => {
      setLoad(false)
      if (result && result.data.statusCode === 200) {
        toast.success(result.data.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          className: classes.successtoaster
        });
        setSelected([])
        list(selectdRow.maintainceType)
        // handleClose()
      }
      else {
        toast.error(result.data.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          className: classes.errortoaster
        });
      }
    }, (error) => {
      setLoad(false)
      toast.error("Service Failed", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        className: classes.errortoaster
      });
       
    })
  }
  }
  // Add Maintaince Reasons
  const handleSubmit = (formData) => {
    setIsLoader(true)
    if (modalData.static.maintainceType ==="reasonType") {
      formData.reasonType = "REASONSUSP"
    }
    if (modalData.static.type ==="holdReason") {
      formData.reasonType = "REASONHOLD"
    }
    formData.maintainceType = selectdRow.maintainceType
    addSettingsReason(formData).then((result) => {
      setIsLoader(false)
      if (result && result.data.statusCode === 200) {
        toast.success(result.data.message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          className: classes.successtoaster
        });
        // handleClose()
        setEmptyFlag(true)
        list(selectdRow.maintainceType)
      } else {
        toast.error(result.data.message, {
          position: "top-center",
          autoClose: 3000,
          className: classes.errortoaster
        });
      }
    }, (error) => {
      setIsLoader(false)
      toast.error("Service Failed", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        className: classes.errortoaster
      });
       
    })
  }

  // get List 
  const list = (value) => {
    getSettingsReason(value).then((result) => {
      if (result && result.data.statusCode === 200) {
        setModalData({
          ...modalData,
          dynamic: result.data.response
        })
      }
      else {
      }
    }, (error) => {
       
    })
  }

  // Get Maintaince Reason List

  const getList = (value) => {
    setIsLoading(true)
    getSettingsReason(value.maintainceType).then((result) => {
      setIsLoading(false)
      if (result && result.data.statusCode === 200) {
        setOpen(true)
        setModalData({
          ...modalData,
          static: value,
          dynamic: result.data.response
        })
      }
      else {
        setIsLoading(false)
      }
    }, (error) => {
      setIsLoading(false)
       
    })
  }

  // Open Reason Modal
  const handleOpen = (value) => {
    setSelected([])
    getList(value)
    setSelectedRow(value)

  }

  // Close Modal
  const handleClose = () => {
    setOpen(false)
  }

  function selectAll() {
    let array = []
    modalData.dynamic.forEach((element, index) => {
      element['isChecked'] = true
      array.push(element.indexId)
    });
    setSelected(array)
    setModalData({
      ...modalData,
      dynamic: modalData.dynamic
    })
  }
  function unSelectAll() {
    modalData.dynamic.forEach((element, index) => {
      element['isChecked'] = false
      setSelected([])
    });
    setModalData({
      ...modalData,
      dynamic: modalData.dynamic
    })
  }
  // Select Reason
  function addElement(addId) {
    modalData.dynamic.forEach((element, index) => {
      if (element.indexId ===addId) {
        element['isChecked'] = true
      }
    });
    selected.push(addId);
    setModalData({
      ...modalData,
      dynamic: modalData.dynamic
    })
  }
  // Unselect Reason
  function removeElement(removeId) {
    for (let i = 0; i < selected.length; i++) {
      if (selected[i] ===removeId) {
        selected.splice(i, 1)
      }
    }
    modalData.dynamic.forEach((element, index) => {
      if (element.indexId ===removeId) {
        element['isChecked'] = false
      }
    });
    setModalData({
      ...modalData,
      dynamic: modalData.dynamic
    })
  }

  // Handle Checkbox add or Remove
  const handleCheckbox = (evt, item) => {
    evt.persist()
    if (evt.target.name === "selectAll") {
      if (evt.target.checked === true) {
        selectAll()
      }
      else {
        unSelectAll()
      }
    }
    else {
      if (evt.target.checked === true) {
        addElement(item.indexId)
      }
      else {
        removeElement(item.indexId)
      }
    }

  }

  const getCategories = ()=>{
    getImagingCategories().then((result)=>{
      if(result && result.data.statusCode === 200){
        setCategories(result.data.response)
      }
      else{

      }
    },(error)=>{
       
    })
  }

  return (
    <>
      <div>
        <div className="permission-menu">  {match !== undefined ? <BreadCrumb breadcrumb={match.url} /> : null}</div>
        {/* {match !== undefined ? <BreadCrumb breadcrumb={match.url} /> : null} */}
        <div className="container mt-3">
          <div className="row">
            {
              settingsDetails && settingsDetails.map((item, index) => {
                return <div className="col-md-3 mb-2 text-center" key={index}>
                  <Button className="font-size-11" disabled={item.disabled} onClick={() => handleOpen(item)}>
                    <div className="card cursor-pointer width100">
                      <div className="card-body">{item.title}</div>
                    </div>
                  </Button>
                </div>

              })
            }
          </div>
        </div>
      </div>
      <AddSettingsModal
        open={open}
        handleRemove={handleRemove}
        handleSubmit={handleSubmit}
        modalData={modalData}
        handleCheckbox={handleCheckbox}
        modalClose={handleClose}
        isLoading={isLoader}
        categories={categories}
        selected={selected}
        load={load}
        emptyFlag={emptyFlag}
      />
      <Notify notifyProps={notifyProps} />
      <Loader open={isLoading} />
      <ToastContainer />
    </>
  );
}
